import { z } from "zod";

export const patchPartnershipReferenceApprovalSchema = z.object({
	isApproved: z.boolean(),
});

export type PatchPartnershipReferenceApprovalSchema = z.infer<
	typeof patchPartnershipReferenceApprovalSchema
>;
